import {
  MESSAGES_OUTBOX_TAB_LOAD_DATA,
  MESSAGES_OUTBOX_TAB_LOAD_DATA_RESULT,
  CLEAR_REDUX
} from "Redux/actionTypes";

const INIT_STATE = {
  loading: false,
  data: [],
  nextToken: null,
  conditions: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case MESSAGES_OUTBOX_TAB_LOAD_DATA:
      return { ...state, loading: true };

    case MESSAGES_OUTBOX_TAB_LOAD_DATA_RESULT:
      return {
        ...state, loading: false,
        data: action.payload.oldNextToken
          ? [...state.data, ...action.payload.items]
          : action.payload.items,
        nextToken: action.payload.nextToken,
        conditions: action.payload.conditions
      };

    case CLEAR_REDUX:
      return ["","MESSAGES_OUTBOX_TAB"].includes(action.payload.option)
        ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
        : { ...state }
        
    default:
      return state;
  }
};
